// Central data source — placeholders for text-only content shown on public pages.
// Conditions/images now live in MongoDB and are managed via /admin.

export const DOCTOR = {
  name: "Dr. Vikas Matai",
  titleShort: "Consultant Minimal Invasive Surgeon",
  titleLong: "MBBS · MS (General Surgery) · FMAS · FIAGES · FISCP · Dip.MAS.",
  whatsapp: "917383073733",
  phoneDisplay: "+91 73830 73733",
  city: "Vadodara, Gujarat",
  yearsPracticing: 13,
  surgeriesPerformed: 1500,
  googleReviewsUrl:
    "https://www.google.com/maps/search/?api=1&query=Dr+Vikas+Matai+Surgeon+Vadodara",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Precision",
    body:
      "Surgery is a discipline of millimetres. Every incision is deliberate, every stitch considered. Nothing is left to improvisation.",
  },
  {
    n: "02",
    title: "Care",
    body:
      "A patient is not a case number. Consultations run long on purpose — because the story matters as much as the scan.",
  },
  {
    n: "03",
    title: "Judgement",
    body:
      "Not every problem requires an operation. When surgery is the answer, it is offered plainly, with the risks and the reasons laid out.",
  },
  {
    n: "04",
    title: "Continuity",
    body:
      "The relationship does not end at discharge. Follow-through — days, months, years — is part of the same practice.",
  },
];

export const CREDENTIALS = [
  { year: "2010", title: "MBBS", inst: "PDU Govt. Medical College, Rajkot" },
  { year: "2015", title: "MS — General Surgery", inst: "MP Shah Govt. Medical College, Jamnagar" },
  { year: "2017", title: "FMAS — Fellowship in Minimal Access Surgery", inst: "World Laparoscopy Hospital" },
  { year: "2017", title: "Dip. MAS. — Diploma in Minimal Access Surgery", inst: "World Laparoscopy Hospital" },
  { year: "2018", title: "FIAGES", inst: "Indian Association of Gastrointestinal Endo-Surgeons" },
  { year: "2018", title: "FISCP — Fellowship in Colorectal Practice", inst: "Indian Society of Colorectal Surgeons" },
];

export const APPOINTMENTS = [
  { title: "Assistant Professor", org: "GMERS Medical College, Vadodara", period: "2021 — 22" },
  { title: "Consultant Minimal-Invasive Surgeon", org: "Welcare Hospital, Atladra", period: "2022 — Present" },
];

export const LOCATIONS = [
  {
    id: "sadguru-akota",
    name: "Sadguru Clinic — Akota",
    address: "Akota, Vadodara 390020",
  },
  {
    id: "welcare-atladra",
    name: "Welcare Hospital — Atladra",
    address: "Atladra, Vadodara 390012",
  },
];

export const SLOTS = [
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "05:00 PM",
  "05:30 PM",
  "06:00 PM",
  "06:30 PM",
];
